export const CATEGORY_TYPES = {
  PERSONAL: "PERSONAL",
  BIG_BUSINESS: "BIG_BUSINESS",
  INFO: "INFORMATION",
  NON_PROFIT: "NON_PROFIT_ORGANIZATIONS",
  UNKNOWN: "DONT_KNOW",
} as const;
